// src/AppV2.tsx
import React from "react";
import { useAppV2ViewModel } from "./viewmodel/AppV2ViewModel";
import { Router } from "./Routing/Router";
import LoadingScreen from "./components/LoadingScreen";
import "./styles/component/LoadingScreen.css"


const AppV2: React.FC = () => {
  const { appReady, delayedReady, error } = useAppV2ViewModel();

  if (error) {
    return (
      <div className="error-message">
        {error}
      </div>
    );
  }

  if (!appReady || !delayedReady) {
    return <LoadingScreen />;
  }

  return <Router />;
};

export default AppV2;
